import { useState } from "react"
import { useInfiniteQuery } from "react-query"

const DEFAULT_INITIAL_INTERVAL = 5000
const DEFAULT_MAX_INTERVAL = 30000
const DEFAULT_BACKOFF_MULTIPLIER = 1.5

export default function usePollingInfiniteQuery({
  queryKey,
  queryFn,
  shouldPoll,
  initialInterval = DEFAULT_INITIAL_INTERVAL,
  maxInterval = DEFAULT_MAX_INTERVAL,
  backoffMultiplier = DEFAULT_BACKOFF_MULTIPLIER,
  ...queryOptions
}) {
  const [refetchInterval, setRefetchInterval] = useState(initialInterval)

  const calculateRefetchInterval = (data) => {
    const flattenedData = data?.pages?.flat() || []
    if (shouldPoll(flattenedData)) {
      return refetchInterval
    }
    return false
  }

  const increaseRefetchInterval = () => {
    setRefetchInterval((prevInterval) => {
      if (prevInterval >= maxInterval) {
        return maxInterval
      }
      return Math.min(Math.round(prevInterval * backoffMultiplier), maxInterval)
    })
  }

  const resetRefetchInterval = () => {
    setRefetchInterval(initialInterval)
  }

  const result = useInfiniteQuery({
    queryKey,
    queryFn: (context) => {
      increaseRefetchInterval()
      return queryFn(context)
    },
    refetchInterval: calculateRefetchInterval,
    refetchIntervalInBackground: true,
    ...queryOptions,
  })

  const flattenedData = result.data?.pages?.flat()

  return {
    ...result,
    flattenedData,
    resetRefetchInterval,
  }
}
